import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { APIPaths } from '@/services/dictionaries/Paths';
import { ScrollIntoViewProps } from './ScrollIntoViewProps';
import usePrevious from '../hooks/usePrevious';

const isException = (url: string, prevUrl: string): boolean => {
    const noScrollUrl = [
        APIPaths.StatisticsLog,
        APIPaths.StatisticsInprogress,
        APIPaths.LogsEmail,
        APIPaths.LogsNotification,
    ];

    return noScrollUrl.some((el): boolean => url === el) && noScrollUrl.some((el): boolean => prevUrl?.includes(el));
};

const ScrollIntoView = (props: ScrollIntoViewProps): JSX.Element => {
    const { pathname } = useLocation();
    const [location, setLocation] = useState(pathname);
    const prevLocation = usePrevious(location);

    useEffect(() => window.scrollTo(0, 0), []);

    useEffect(() => {
        setLocation(pathname);

        if (isException(pathname, prevLocation)) {
            return;
        }

        if (pathname !== prevLocation) {
            const container = document.getElementById('econtent_wrapper');
            container ? (container.scrollTop = 0) : window.scrollTo(0, 0);
        }
    }, [pathname]);

    return props.children;
};

export default ScrollIntoView;
